<template>
  <div class="main">
    <c-panel>
      <form-entrada :paramId="$route.params.id" v-on:onSubmitEntrada="onSubmitEntrada"></form-entrada>
    </c-panel>
  </div>
</template>
<script>
import formEntrada from "./form"

export default {
  methods: {
    onSubmitEntrada () {
      this.$router.push('/admin/merenda/entrada')
    }
  },
  components: { formEntrada }
}
</script>

